import { useCurrency } from "./CurrencyContext";

const OPTIONS = [
  { code: "BRL", label: "R$" },
  { code: "USD", label: "US$" },
  { code: "EUR", label: "€" },
];

export default function CurrencySwitcher({ dark = false }) {
  const { currency, setCurrency } = useCurrency();

  return (
    <div
      data-testid="currency-switcher"
      className={`flex items-center rounded-full border overflow-hidden ${dark ? "border-white/25" : "border-stone-200"}`}
      role="group"
      aria-label="Moneda"
    >
      {OPTIONS.map((o) => (
        <button
          key={o.code}
          data-testid={`currency-${o.code.toLowerCase()}-btn`}
          onClick={() => setCurrency(o.code)}
          className={`px-2.5 py-2 text-[11px] font-bold tracking-wide transition-colors ${
            currency === o.code
              ? "bg-[#D9A854] text-[#0B2E4A]"
              : dark
                ? "text-stone-300 hover:text-white"
                : "text-stone-500 hover:text-stone-800"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
